import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

const application = Application.start()
const context = require.context('../components', true, /_controller.js$/)
application.load(simplifiedDefinitionsFromContext(context))

// definitionsFromContext returns identifiers in the form of folder-name--file-name, which is unnecessarily verbose
function simplifiedDefinitionsFromContext (context) {
  return definitionsFromContext(context).map(d => simplifyIdentifier(d))
}

function simplifyIdentifier (definition) {
  definition.identifier = definition.identifier.split('--').slice(-1)[0]
  return definition
}
